import {Component, Input, ViewChild} from '@angular/core';
import {DrugProcessingBaseDirective} from '../drug-processing-base.directive';

@Component({
  selector: 'app-sell-to-pharmacy-dialog',
  templateUrl: './sell-to-pharmacy-dialog.component.html',
  styleUrls: ['./sell-to-pharmacy-dialog.component.scss', './../user-board-dialog.scss'],
})
export class SellToPharmacyDialogComponent extends DrugProcessingBaseDirective {
  @Input() show: boolean;

  @ViewChild('descriptionInput') descriptionInput;
  @ViewChild('addedQuantityInput') addedQuantityInput;

  @ViewChild('submitButton') submitButton;
  @ViewChild('closeButton') closeButton;

  optionSelected(option: any): void {
    super.optionSelected(option);
    setTimeout(() => this.focusInput('descriptionInput'), 100);
  }

  focusInput(inputName: string): void {
    setTimeout(() => this[inputName] && this[inputName]?.appInput?.nativeElement?.focus());
  }

  focusButton(buttonName: string): void {
    setTimeout(() => this[buttonName]?.focus());
  }
}
